import {isArray} from 'lodash';


const models = {};

export function getModel(name) {
    return models[name];
}

export function wrapModelLoaderAsBeforeRouterEnterHook(name, loader) {
    let loaders = isArray(name) ? name : [{name, loader}];

    return async function beforeEnter(to, from, next) {
        loaders = loaders.filter(({name}) => !models[name]);

        if (!loaders.length) {
            next();
            return;
        }

        try {
            await Promise.all(loaders.map(({name, loader}) =>
                loader().then(res => {
                    models[name] = res.default;
                })
            ));
        }
        catch (err) {
            next(err);
            return;
        }

        next();
    };
}
